var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconConsulting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.33,135.26l-2.45-.73,2.29-1.13a70.36,70.36,0,1,0-63.76-.73l2.23,1.17-2.43.69A126.06,126.06,0,0,0,36.39,171C20,189.35,11.33,210.58,11.33,232.46V256H244.67V232.46C244.67,185.42,201.74,148,159.33,135.26ZM72.77,70.35A55.23,55.23,0,1,1,128,125.58,55.29,55.29,0,0,1,72.77,70.35Zm47.69,170.54h-94v-8.43c0-27.92,19.74-63.6,63.82-80.39l.76-.29,29.44,45.52Zm-14.3-93.53,1.46-.28a94.18,94.18,0,0,1,18.18-1.82,99.53,99.53,0,0,1,22.14,2.61l1.39.32-21.31,33Zm123.4,93.53h-94V197.3l28.7-44.38.77.31c32.11,12.79,64.52,42.25,64.52,79.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConsulting);
export default __webpack_public_path__ + "static/media/icon-consulting.b5b4d879.svg";
export { ForwardRef as ReactComponent };